import { Dispatch, SetStateAction, useEffect, useState } from 'react';

/**
 * Return [state, delayedState, setState]
 * delayedState - state is returned after 250ms
 */
export function useDelayedState<S>(
  initialState: S | (() => S),
  delayedCallback?: (state: S) => void,
): [S, S, Dispatch<SetStateAction<S>>];
export function useDelayedState<S = undefined>(): [
  S | undefined,
  S | undefined,
  Dispatch<SetStateAction<S | undefined>>,
];
export function useDelayedState(initialState = undefined, delayedCallback = (_state: unknown): void => undefined) {
  const [state, setState] = useState(initialState);
  const [delayedState, setDelayedState] = useState(initialState);

  useEffect(() => {
    const id = setTimeout(() => {
      setDelayedState(state);
      delayedCallback(state);
    }, 250);

    return () => clearTimeout(id);
  }, [state, delayedCallback]);

  return [state, delayedState, setState];
}
